import { render, staticRenderFns } from "./miaotixing.vue?vue&type=template&id=0c283f32&scoped=true"
import script from "./miaotixing.vue?vue&type=script&lang=js"
export * from "./miaotixing.vue?vue&type=script&lang=js"
import style0 from "./miaotixing.vue?vue&type=style&index=0&id=0c283f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c283f32",
  null
  
)

export default component.exports